import React from 'react';
import {
  Button, ButtonColor, FontWeight, Spacing, SpacingName, Typography,
} from '@doveit/lego';
import { useRouter } from 'next/router';
import BannerStripe from '../../components/banner-stripe/BannerStripe';
import Markdown from '../../components/markdown/Markdown';
import PageSection from '../../components/page-section/PageSection';

export interface BannerSectionProps {
  title: string,
  subtitle?: string,
  content: string,
  image: {
    url: string,
    alt: string,
  },
  action: {
    label: string,
    href: string,
  },
}

export const BannerSection: React.FC<BannerSectionProps> = ({
  title,
  subtitle,
  content,
  image,
  action,
}) => {
  const { push } = useRouter();

  return (
    <PageSection>
      <BannerStripe
        imageURL={image.url}
        imageAlt={image.alt}
      >
        <Typography.H2
          color="brand.primary"
          uppercase
        >
          {title}
        </Typography.H2>
        {subtitle && (
          <Spacing margin={[SpacingName.SMALL, 0]}>
            <Typography.H3
              tagName="p"
              fontWeight={FontWeight.LIGHT}
            >
              {subtitle.trim()}
            </Typography.H3>
          </Spacing>
        )}
        <Spacing margin={[SpacingName.SMALL, 0]}>
          <Typography.H4
            tagName="p"
            fontWeight={FontWeight.LIGHT}
          >
            <Markdown>
              {content.trim()}
            </Markdown>
          </Typography.H4>
        </Spacing>
        <Button
          label={action.label}
          color={ButtonColor.PRIMARY}
          onClick={() => push(action.href)}
        />
      </BannerStripe>
    </PageSection>
  );
};

export default BannerSection;
